// extracted by mini-css-extract-plugin
export default {"h1":"headers_h1__JmwMv","h2":"headers_h2__qOxuT","h3":"headers_h3__whTTu","h4":"headers_h4__g2pH7","h5":"headers_h5__A8EsF","h6":"headers_h6__B4Mtm"};